export default (cfg, childs) => {
  const tags = cfg.h
  const ul = tags.ul
  const li = tags.li

  return (
    ul('.byline', childs.map(child =>
      li([child])
    )))
}
